// GET /v1/billing/subscription — current Stripe subscription state
// for the active billing context (user or org). Used by BillingPage
// to render the "Active until X" / "Past due" / "Cancel pending"
// banners and by PlansPanel to highlight the current plan card.
const action = "BILLING_SUBSCRIPTION";
export const REQUEST  = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE  = action + '_FAILURE';
export const CLEAR    = action + '_CLEAR';

export const fetchRequest = () => ({ type: REQUEST });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error)    => ({ type: FAILURE,  payload: error });
export const clearState   = ()          => ({ type: CLEAR });
